export default "__VITE_ASSET__DcRM4Omk__"